import { forwardRef } from 'react';
import { NumberFormatBase, NumberFormatBaseProps } from 'react-number-format';

/**
 * Voir : https://s-yadav.github.io/react-number-format/docs/customization#iban-account-input-field-with-pattern
 */
export const IbanInput = forwardRef<NumberFormatBaseProps>((props, ref) => {
    return (
        <NumberFormatBase
            {...props}
            type="text"
            inputMode="text"
            format={(value) =>
                value
                    .replace(/\s+/g, '')
                    .replace(/([a-z0-9]{4})/gi, '$1 ')
                    .trim()
                    .toLocaleUpperCase()
            }
            removeFormatting={(value) => value.replace(/\s+/gi, '')}
            isValidInputCharacter={(char) => /^[a-z0-9]$/i.test(char)}
            getCaretBoundary={(value) =>
                Array(value.length + 1)
                    .fill(0)
                    .map(() => true)
            }
            onKeyDown={(e) => !/^(?:[a-z0-9]|Backspace|Delete|Home|End|ArrowLeft|ArrowRight|Shift|CapsLock|Control|NumLock|Tab|Paste|Redo|Undo)$/i.test(e.key) && e.preventDefault()}
            getInputRef={ref}
        />
    );
});
